import { Broadcast, Heart, ListDashes, Gear } from "@phosphor-icons/react";

const cn = (...a) => a.filter(Boolean).join(" ");

const NAV = [
  { key: "channels", label: "Kanäle", icon: ListDashes, testid: "bottomnav-channels" },
  { key: "nowplaying", label: "Live", icon: Broadcast, testid: "bottomnav-nowplaying" },
  { key: "favorites", label: "Favoriten", icon: Heart, testid: "bottomnav-favorites" },
  { key: "settings", label: "Einstellungen", icon: Gear, testid: "bottomnav-settings" },
];

export default function BottomNav({ active, onChange, onOpenDrawer }) {
  return (
    <nav
      className="md:hidden shrink-0 border-t border-[#18181B] bg-white grid grid-cols-4 relative z-50"
      data-testid="mobile-bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {NAV.map(({ key, label, icon: Icon, testid }) => {
        const isActive = active === key;
        const handleClick = (e) => {
          e.stopPropagation();
          onChange(key);
          if (key === "channels" && onOpenDrawer) onOpenDrawer();
        };
        return (
          <button
            key={key}
            onClick={handleClick}
            data-testid={testid}
            className={cn(
              "min-h-[56px] flex flex-col items-center justify-center gap-0.5 py-1 transition-colors",
              isActive ? "bg-[#18181B] text-white" : "text-[#52525B] hover:bg-[#F4F4F5]"
            )}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon size={20} weight={isActive ? "fill" : "regular"} />
            <span className="text-[0.62rem] font-mono-tech tracking-[0.1em] uppercase">
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
